var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyncPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#34485E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2452 13.1103C11.9604 13.4265 11.9979 13.8162 12.2977 14.0221C12.5901 14.2279 12.9424 14.1618 13.1897 13.8897C14.3591 12.5809 16.0832 11.75 18.0022 11.75C21.2631 11.75 23.9242 14.125 24.314 17.2206H23.197C22.6648 17.2206 22.5299 17.5735 22.8147 17.9779L24.4939 20.3235C24.7338 20.6618 25.0936 20.6691 25.3409 20.3235L27.0126 17.9853C27.3124 17.5735 27.17 17.2206 26.6303 17.2206H25.6033C25.191 13.4779 21.9077 10.5 18.0022 10.5C15.7159 10.5 13.6545 11.5147 12.2452 13.1103ZM8.98443 18.0221C8.69208 18.4265 8.82701 18.7868 9.36673 18.7868H10.4012C10.806 22.5294 14.0968 25.5 18.0022 25.5C20.2886 25.5 22.3575 24.4779 23.7668 22.8897C24.0441 22.5735 24.0066 22.1765 23.7143 21.9706C23.4219 21.7647 23.0621 21.8382 22.8222 22.1103C21.6603 23.4265 19.9362 24.25 18.0022 24.25C14.7339 24.25 12.0728 21.875 11.6905 18.7868H12.8074C13.3397 18.7868 13.4746 18.4265 13.1897 18.0294L11.5106 15.6838C11.2707 15.3456 10.9109 15.3382 10.6636 15.6838L8.98443 18.0221Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncPrimary);
export default __webpack_public_path__ + "static/media/SyncPrimary.f8fcd87949330f343225352d6a2835b0.svg";
export { ForwardRef as ReactComponent };